import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { API } from "@/lib/api";

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      // Also check URL search params as fallback
      const params = new URLSearchParams(window.location.search);
      const sessionFromParams = params.get("session_id");
      if (!sessionFromParams) {
        navigate("/login", { replace: true });
        return;
      }
      exchangeSession(sessionFromParams);
      return;
    }
    exchangeSession(match[1]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, setUser]);

  const exchangeSession = async (sessionId) => {
    // Retry up to 2 times in case of timing issues
    for (let attempt = 0; attempt < 2; attempt++) {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) {
          if (attempt === 0) {
            await new Promise(r => setTimeout(r, 1000));
            continue;
          }
          throw new Error("Session exchange failed");
        }
        const userData = await res.json();
        if (userData.session_token) {
          localStorage.setItem("session_token", userData.session_token);
        }
        setUser(userData);
        if (userData.onboarded) {
          navigate("/dashboard", { replace: true });
        } else {
          navigate("/onboarding", { replace: true });
        }
        return;
      } catch (err) {
        if (attempt === 1) {
          console.error("Auth callback error:", err);
          navigate("/login", { replace: true });
        }
      }
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 border-3 border-[#E91E8C] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-zinc-400">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
